import { useTimeFormatter } from './useTimeFormatter';

interface BookingValidatorProps {
  number?: number | undefined;
  type?: number | undefined;
  bookingWindowOpen?: boolean;
}

export const useEventFieldValidator = () => {
  const { formatTimeAsNumberToBackendPattern } = useTimeFormatter();

  const timeFieldValidator = ({ number, type, bookingWindowOpen = true }: BookingValidatorProps) =>
    !!number && number.toString().length <= 3 && bookingWindowOpen
      ? formatTimeAsNumberToBackendPattern(number, type)
      : undefined;

  return { timeFieldValidator };
};
